import { render, staticRenderFns } from "./CompensationAnalytics.vue?vue&type=template&id=198d33ba"
import script from "./CompensationAnalytics.vue?vue&type=script&lang=js"
export * from "./CompensationAnalytics.vue?vue&type=script&lang=js"
import style0 from "./CompensationAnalytics.vue?vue&type=style&index=0&id=198d33ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports